import index from "./reports.vue";
export default index;
